import { Auth0Provider as Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

import env from 'env';

/**
 * Provider for useAuth0
 */
export const Auth0Provider = ({ children }: { children?: React.ReactNode }) => {
  const navigate = useNavigate();

  return (
    <Provider
      domain={env.auth0Domain}
      clientId={env.auth0AppClientID}
      authorizationParams={{ audience: env.auth0Audience }}
      // This setting is required for private tabs to function
      cacheLocation="localstorage"
      // The returnTo is set during login flow, and redirect happens here if successful
      onRedirectCallback={state => state?.returnTo && navigate(state.returnTo, { replace: true })}
    >
      {children}
    </Provider>
  );
};
